import React from "react";
import { useSelector } from "react-redux";
import DashboardBalanceItem from "./dashboardBalanceItem/DashboardBalanceItem";



export default function DashboardBalance(props) {
  const { userType: role } = useSelector((state) => state.auth.user);
  const {dashBalance, dashStock, minimumBalance} = props

  return (
    <section className="container-fluid">
      <div className="row">
        { role !== 3 && <DashboardBalanceItem text="Balance" dashBalance={dashBalance} minimumBalance={minimumBalance}/> }
        { role !== 3 && <DashboardBalanceItem text="Stock" dashStock={dashStock}/> }
        {/* <DashboardBalanceItem text="Order Status" dashOrders={dashOrders}/> */}
      </div>
    </section>
  );
}
